import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import { ReactComponent as IconShare } from 'images/share.svg';
import Page from 'modules/app/components/Page';
// import Button from 'components/shared/Button';
import useGetHashtag from 'sdk/hooks/discovery/useGetHashtag';
import useGetHashtagPosts from 'sdk/hooks/discovery/useGetHashtagPosts';
import useUserPosts from 'sdk/hooks/user/useUserPosts';
import PostView from 'components/shared/PostView';
import ShareModal from 'modules/feed/components/Feed/ShareModal';
import s from './Hashtag.module.scss';

function Hashtag() {
  const { id } = useParams()
  const { data: hashtag } = useGetHashtag(id)
  const { data: ids } = useGetHashtagPosts(id)
  const { data: posts } = useUserPosts(ids || [])
  const [isShareModal, setIsShareModal] = useState(false)

  const handleOpenShareModal = () => {
    setIsShareModal(true)
  }

  const handleCloseShareModal = () => {
    setIsShareModal(false)
  }

  const navigate = useNavigate()

  return (
    <>
      <div
        className={s.container}
        style={{
          background: `linear-gradient(180deg, ${hashtag?.color} 33.74%, rgba(255, 116, 0, 0) 60%)`,
        }}
      >
        <div className={s.headerRow}>
          <div
            className={s.h}
            onClick={() => {
              navigate(-1)
            }}
          >
            <h1>
              <IconArrowRight />
            </h1>
          </div>
          <div className={s.right}>
            {/* <Button className={s.followBtn}>
            Follow
          </Button> */}
            <IconShare className={s.shareIcon} onClick={handleOpenShareModal} />
          </div>
        </div>
        <div className={s.body}>
          <h2 className={s.title}>
            {hashtag?.label}
            <span className={s.hashtagsLength}>{posts?.length}</span>
          </h2>
          <div className={s.playList}>
            {posts?.map((post: any, index: number) => (
              <Link to={`/search/feed/${post?.id}`} state={{ ids, active: index }} className={s.postLink} key={post?.id}>
                <PostView
                  key={post?.id}
                  data={{ data: post }}
                  size={4}
                  gridItemSize="small"
                  grid
                  className={s.post}
                />
              </Link>
            ))}
            {/* </div> */}
          </div>
        </div>
      </div>
      <ShareModal
        isOpen={isShareModal}
        onClose={handleCloseShareModal}
      />
    </>
  )
}

function HashtagPage() {
  return (
    <Page activeLink="/">
      <Hashtag />
    </Page>
  )
}

export default HashtagPage
